export default __webpack_public_path__ + "static/industry_expert_blog_bus-2924f0499466d8961581a546516f20a7.svg";